<template>
  <div>
    <ul :class="['specs p-0 m-0', { 'show-more-specs': showMoreSpec }]">
      <li v-for="({ title }, index) in specs" :key="index" class="item">
        <Icon
          icon="tick-v1"
          :width="11"
          :height="11"
          :color="highlighted ? 'var(--primary-color)' : 'var(--white-color)'"
          class="icon"
          :exp-active="true"
          :style="
            highlighted ? 'background:var(--white-color)' : 'background: var(--primary-color)'
          "
        />
        {{ title }}
      </li>
    </ul>
    <span
      v-show="specs.length > 3"
      class="toggle-show-more-specs"
      :class="{ 'text-white': highlighted }"
      @click="showMoreSpec = !showMoreSpec"
    >
      {{ showMoreSpec ? seeLess : seeMore }}
    </span>
  </div>
</template>
<script>
import Icon from 'UI/Icon';
export default {
  components: { Icon },
  props: {
    specs: {
      type: Array,
      required: true,
      validator: (specs) => {
        return specs.every((spec) => spec.title && spec.active);
      }
    },
    seeMore: {
      type: String,
      required: true
    },
    seeLess: {
      type: String,
      required: true
    },
    highlighted: {
      type: Boolean,
      required: true
    }
  },
  data: () => {
    return {
      showMoreSpec: false
    };
  }
};
</script>
<style lang="scss" scoped>
.specs {
  list-style: none;
  display: grid;
  gap: 0.5em;
  .item:nth-child(n + 4) {
    display: none;
  }
  &.show-more-specs .item {
    display: flex;
  }
  .item {
    font-size: 0.9em;
    color: var(--text-color);
    display: flex;
    align-items: baseline;
    gap: 0.5em;
  }
  .icon {
    border-radius: 6px;
    padding: 4px;
  }
}
.toggle-show-more-specs {
  color: $gray;
  font-weight: 400;
  font-size: 12px;
  border-bottom: 2px solid;
  width: max-content;
  cursor: pointer;
}
</style>
